// TODO: disclaimer message before redirecting to overcast
import QRCode from "qrcode";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import queryString from "query-string";
import mixpanel from "mixpanel-browser";
import { isMobile } from "react-device-detect";

const FRONTEND_ENDPOINT = process.env.REACT_APP_FRONTEND_URL;
// const FRONTEND_ENDPOINT = "http://192.168.1.66:3000";

function Android(props) {
  const [qrCode, setQrCode] = useState();
  const [showInstructions, setShowInstructions] = useState(false);
  const articleUrl = queryString.parse(props.location.search).article_url;
  const feedUrl = queryString.parse(props.location.search).feed_url;
  const isOnboarding = queryString.parse(props.location.search).is_onboarding;

  useEffect(() => {
    mixpanel.track("Open Android Page (Onboarding)");
  }, []);
  QRCode.toDataURL(
    `https://subscribeonandroid.com/${feedUrl.replace("https://", "")}`
  )
    .then((url) => {
      setQrCode(url);
    })
    .catch((err) => {
      console.error(err);
    });
  return (
    <div className="center">
      <>
        {isMobile ? (
          <>
            <a
              className="transparent-button"
              href={`https://subscribeonandroid.com/${feedUrl.replace(
                "https://",
                ""
              )}`}
              target="_blank"
            >
              Click This to Subscribe
            </a>

            <h2 className="subheadline">
              Finish subscribing to your private podcast channel in the app and
              come back here
            </h2>
          </>
        ) : (
          <>
            <h1 className="headline">Scan QR Code </h1>
            <h2
              style={{
                display: !showInstructions ? "block" : "none",
              }}
              onClick={(e) => {
                setShowInstructions(true);
                mixpanel.track("Click How to Scan (Onboarding)");
              }}
              className="subheadline clickable"
            >
              How to scan?
            </h2>
            <div
              style={{
                display: showInstructions ? "block" : "none",
              }}
            >
              <div>1. Open the default Camera app. </div>
              <div>2. Face the QR code for 3 seconds.</div>
              <div>3. Click the popup at the top. </div>
            </div>
            <img
              src={qrCode}
              alt="your qr code"
              width="250"
              height="auto"
              style={{ margin: "30px" }}
            ></img>
          </>
        )}
        {isOnboarding !== "false" && (
          <div className="cta-div">
            <Link
              to="/add"
              onClick={(e) => {
                mixpanel.track("Successful Podcast Subscription (Onboarding)");
              }}
            >
              <button className="cta-button">I subscribed successfully</button>
            </Link>
            <a
              href="https://www.tidio.com/talk/gzpx0hksecqrxjt9t2vix680h5aiodfj"
              target="_blank"
              className="sub-cta-link"
              onClick={(e) => {
                mixpanel.track(
                  "Unsuccessful Podcast Subscription (Onboarding)"
                );
              }}
            >
              I have issues subscribing
            </a>
          </div>
        )}
      </>
    </div>
  );
}

export default Android;
